// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"25507ac0","480":"c76a02cb","487":"4d627e53","673":"f986556d"}[chunkId] + ".chunk.js";
};